import { render, staticRenderFns } from "./ScreenshotCarousel.vue?vue&type=template&id=e98311f4&"
import script from "./ScreenshotCarousel.vue?vue&type=script&lang=js&"
export * from "./ScreenshotCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports